// Single source of truth for "render gallons for the operator". One decimal
// place across the dashboard: hero stat, chart tooltip, status footer.
export function formatGallons(value: number): string {
  return `${value.toLocaleString('en-US', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  })} gal`;
}
